import { sourceLabel, formatTs } from '../../sales_task_list/advisors/advisors';

// null advisor -> no label; expiry uses the Advisors-tab IST formatter.
const salesAdvisorLabel = (advisor) => {
  if (!advisor || !advisor.name) return null;
  const parts = [
    sourceLabel(advisor.source) || advisor.source,
    advisor.expires_at && `expires ${formatTs(advisor.expires_at)}`
  ];
  return {
    text: `Sales advisor: ${advisor.name}`,
    detail: parts.filter(Boolean).join(', ')
  };
};

// apis sends `sales_advisor: null` when nobody is assigned; undefined (older server) shows nothing.
export const hasNoAdvisor = (advisor) => advisor === null;

export default salesAdvisorLabel;
